import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";

/**
 * Stripe Checkout cancel_url lands with ?cancelled_ref=LEM-… — surface a
 * once-per-ref toast and strip the param so refresh doesn't re-fire.
 */
export function useCheckoutCancelledToast() {
  const [searchParams, setSearchParams] = useSearchParams();
  const toastedRef = useRef<string | null>(null);

  useEffect(() => {
    const cancelledRef = searchParams.get("cancelled_ref");
    if (!cancelledRef) return;
    if (toastedRef.current === cancelledRef) return;
    toastedRef.current = cancelledRef;

    toast("Order saved. Payment paused.", {
      description: `Your gift request (${cancelledRef}) is safe. Resume when you're ready from Orders, or we'll follow up by email.`,
      duration: 9000,
    });

    const next = new URLSearchParams(searchParams);
    next.delete("cancelled_ref");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);
}
